function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(13 7)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#979797",
  cx: 251.5,
  cy: 268.5,
  r: 140.5
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 239)"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#F5F5F5",
  strokeWidth: 15,
  fill: "#E6E6E6",
  cx: 110.5,
  cy: 110.5,
  r: 103
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "KontrapunktMiki-Regular, Kontrapunkt Miki",
  fontSize: 26,
  fill: "#000"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 60.931,
  y: 117
}, "Strategy"))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(139)"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#F5F5F5",
  strokeWidth: 14.983,
  fill: "#E6E6E6",
  cx: 111.5,
  cy: 110.5,
  r: 103.008
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "KontrapunktMiki-Regular, Kontrapunkt Miki",
  fontSize: 26,
  fill: "#000"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 45.428,
  y: 117
}, "Experience"))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(279 239)"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#F5F5F5",
  strokeWidth: 15,
  fill: "#E6E6E6",
  cx: 110.5,
  cy: 110.5,
  r: 103
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "KontrapunktMiki-Regular, Kontrapunkt Miki",
  fontSize: 26,
  fill: "#000"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 65.182,
  y: 117
}, "Identity"))));

function SvgApproachCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 528 471"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,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";
export { SvgApproachCircle as ReactComponent };